import React from 'react';
import { useNavigate } from 'react-router-dom';
import Sym from '../components/Sym';

/**
 * Teaser de Seguridad (banda oscura). Copy AJUSTADO (decisiones §4.4/§4.5):
 *  - Sin ISO/IEC 27001 (no está certificado).
 *  - Sin "alojamos todo en México" — se suaviza a lo verificable.
 * Presumimos solo lo real: AES-256, respaldos diarios, acceso por rol, uso acotado.
 */
const CERTS = [
  { icon: 'lock', t: 'Cifrado AES-256' },
  { icon: 'backup', t: 'Respaldos diarios' },
  { icon: 'admin_panel_settings', t: 'Acceso por rol' },
  { icon: 'shield_lock', t: 'e.firma aislada' },
  { icon: 'account_balance', t: 'Solo consulta al SAT' },
  { icon: 'restart_alt', t: 'Revócala cuando quieras' },
];

const SecurityTeaser2 = () => {
  const navigate = useNavigate();
  return (
    <section data-dark style={{ position: 'relative', overflow: 'clip', background: 'linear-gradient(160deg,#0A1326,#00173D)', padding: 'clamp(52px,7vw,92px) 0', borderTop: '1px solid rgba(255,255,255,.06)', borderBottom: '1px solid rgba(255,255,255,.06)' }}>
      <div style={{ position: 'absolute', top: -100, left: -60, width: 360, height: 360, borderRadius: '50%', background: 'radial-gradient(circle,rgba(47,107,255,.32),transparent 65%)', filter: 'blur(10px)' }} />
      <div style={{ position: 'relative', maxWidth: 1100, margin: '0 auto', padding: '0 clamp(20px,5vw,40px)', display: 'flex', flexWrap: 'wrap', gap: 'clamp(28px,4vw,56px)', alignItems: 'center' }}>
        <div style={{ flex: '1 1 380px', minWidth: 280 }}>
          <span style={{ font: "700 .8rem 'IBM Plex Mono'", letterSpacing: '.14em', textTransform: 'uppercase', color: '#6FA0FF' }}>Seguridad</span>
          <h2 style={{ font: "600 clamp(1.9rem,4vw,2.9rem)/1.06 'Source Serif 4'", letterSpacing: '-.02em', color: '#fff', margin: '12px 0 16px', textWrap: 'balance' }}>
            Tu e.firma, tratada como <span style={{ fontStyle: 'italic', color: '#6FA0FF' }}>el tesoro que es</span>
          </h2>
          <p style={{ font: "400 1.08rem/1.6 'Hanken Grotesk'", color: '#AEBAD2', margin: '0 0 24px', maxWidth: 520 }}>
            Ciframos tu e.firma y toda tu información con AES-256, hacemos respaldos diarios y cada colaborador ve únicamente lo suyo. PaySlip la usa solo para descargar tus recibos del SAT.
          </p>
          <a
            onClick={() => navigate('/seguridad')}
            style={{ display: 'inline-flex', alignItems: 'center', gap: 8, font: "700 1rem 'Hanken Grotesk'", color: '#fff', cursor: 'pointer' }}
            onMouseEnter={(e) => { e.currentTarget.style.color = '#6FA0FF'; }}
            onMouseLeave={(e) => { e.currentTarget.style.color = '#fff'; }}
          >
            Conoce nuestra seguridad<Sym name="arrow_forward" size={20} />
          </a>
        </div>
        <div style={{ flex: '1 1 300px', minWidth: 260, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
          {CERTS.map((c) => (
            <div key={c.t} style={{ display: 'flex', alignItems: 'center', gap: 11, background: 'rgba(255,255,255,.04)', border: '1px solid rgba(255,255,255,.1)', borderRadius: 14, padding: '14px 16px' }}>
              <Sym name={c.icon} size={22} color="#6FA0FF" />
              <span style={{ font: "600 .92rem 'Hanken Grotesk'", color: '#DCE4F5' }}>{c.t}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SecurityTeaser2;
